import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { GbuModel } from 'src/app/models/gbu/GbuModel';
import { IGbuModel } from 'src/app/models/interfaces/gbus/IGbuModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { GbuService } from 'src/app/services/Gbu/gbu.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';

@Component({
  selector: 'app-configuracion-gbu-registrar',
  templateUrl: './configuracion-gbu-registrar.component.html',
  styleUrls: ['./configuracion-gbu-registrar.component.css']
})
export class ConfiguracionGbuRegistrarComponent implements OnInit {
  model: IGbuModel = new GbuModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private router: Router,
    private gbuService: GbuService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.gbuService.submit(this.model).subscribe((data) => {
            this.alertDialogService.open("El GBU fue registrado");
            this.router.navigate(['/configuracion', 'gbu']);  
          });
        }
      });
    }
  }

}
